import React from "react";
import Svg, {
  Path,
  Defs,
  LinearGradient,
  Stop,
  Rect,
  G,
  ClipPath,
} from "react-native-svg";
import { TouchableOpacity } from "react-native";

export default function ReflectIcon(props) {
  const color = props.fillColor || "#05858A";
  const color2 = props.fillColor2 || "#2AE8CB";

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_reflect)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2093 6.99179C14.2093 8.20185 13.2203 9.1828 12.0002 9.1828C10.7802 9.1828 9.79115 8.20185 9.79115 6.99179C9.79115 5.78173 10.7802 4.80078 12.0002 4.80078C13.2203 4.80078 14.2093 5.78173 14.2093 6.99179ZM19.1529 13.5351C14.5105 15.0726 9.49016 15.0726 4.8478 13.5351C3.8218 13.1991 3.29653 12.1912 3.65489 11.4025C3.67993 11.3404 3.70698 11.2783 3.73347 11.2174C3.74852 11.1829 3.76339 11.1487 3.77762 11.1152C3.97079 10.7323 4.29893 10.4331 4.69978 10.2742C5.10064 10.1154 5.54634 10.108 5.95235 10.2534C9.87782 11.5534 14.1229 11.5534 18.0483 10.2534C18.4555 10.1104 18.9013 10.1207 19.3013 10.2822C19.7013 10.4438 20.0276 10.7454 20.2182 11.1298L20.3458 11.4171C20.7042 12.1912 20.1789 13.1991 19.1529 13.5351ZM21.0722 16.9725H2.9282C1.97385 16.9725 1.2002 17.7398 1.2002 18.6863C1.2002 19.6329 1.97385 20.4002 2.9282 20.4002H21.0722C22.0265 20.4002 22.8002 19.6329 22.8002 18.6863C22.8002 17.7398 22.0265 16.9725 21.0722 16.9725Z"
            fill="url(#paint0_linear_reflect)"
          />
        </G>
        <Defs>
          <LinearGradient
            id="paint0_linear_reflect"
            x1="1.20019"
            y1="8.18379"
            x2="7.17571"
            y2="25.0903"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor={color} />
            <Stop offset="1" stopColor={color2} />
          </LinearGradient>
          <ClipPath id="clip0_reflect">
            <Rect
              width="21.6"
              height="15.6"
              fill="white"
              transform="translate(1.2002 4.80078)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
